import { theme } from '@frontend/theme';
import { HeaderBaseProps } from '../types';

export const HeaderRow = ({ children, css, ...rest }: HeaderBaseProps) => {
  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          gap: `${theme.spacing(0.75)}`,
          maxHeight: '36px',
        },
        css,
      ]}
      {...rest}
    >
      {children}
    </div>
  );
};
